import "./ShippingPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Shipping from "./sections/Shipping";
import CustomerCare from "./sections/CustomerCare";
import Footer from "@/reusable_sections/Footer";
export default function ShippingPolicyPage() {
  return <div>
      <Header />
      <Shipping />
      <CustomerCare />
      <Footer />
    </div>;
}